import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dataTestId", "multi", "onChange", "options", "placeholder", "placement", "readOnly", "value"];
import PropTypes from 'prop-types';
import UISelect from 'UIComponents/input/UISelect';
import { OptionType } from 'automation-ui-core/prop-types/OptionTypes';
import { useQuery } from 'data-fetching-client';
import { GET_TEAMS } from 'automation-ui-action-features/users-and-teams/teamQueries';
import { toTeamOptions } from 'automation-ui-action-features/users-and-teams/teamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const TeamSelect = _ref => {
  let {
      dataTestId,
      multi,
      onChange,
      options = [],
      placeholder,
      placement,
      readOnly,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    data
  } = useQuery(GET_TEAMS);
  const teamOptions = toTeamOptions(data && data.teams);
  return /*#__PURE__*/_jsx(UISelect, Object.assign({
    anchorType: "button",
    "data-test-id": dataTestId,
    dropdownClassName: "config-dropdown-options",
    menuWidth: "auto",
    multi: multi,
    onChange: onChange,
    options: options.concat(teamOptions),
    placeholder: placeholder,
    placement: placement || 'bottom left',
    readOnly: readOnly,
    value: value
  }, rest));
};
TeamSelect.propTypes = {
  dataTestId: PropTypes.string,
  multi: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(OptionType.isRequired),
  placeholder: PropTypes.string,
  placement: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
};
export default TeamSelect;